import Vue from 'vue'
import Vuex from 'vuex'
import {
  isLogin,getUserInfo
} from '../utils/dataStorage'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin:isLogin(),
    //sysuser:getUserInfo()
  },
  mutations: {
    isLogin(state){
      state.isLogin=isLogin();
    },
    // setUserInfo(state){
    //   state.sysuser=getUserInfo()
    // }
  },
  actions: {

  }
})
